import { useMemo } from "react";
import { Loading } from "@/components/atoms";
import { DataTable } from "@/components/molecules";
// import { useProfile } from "@/hooks";
import { clsx } from "@/utils";
import { addToast } from "@/utils";
import { generateColumns, generateData, SubscriptionBillingItem } from "./helpers";

interface SubscriptionBillingHistoryTableProps extends React.HTMLAttributes<HTMLDivElement> {
  items: SubscriptionBillingItem[];
  isLoading?: boolean;
}

export const SubscriptionBillingHistoryTable = ({ items, isLoading, className, ...props }: SubscriptionBillingHistoryTableProps) => {
  // const { dateFormat } = useProfile();
  const dateFormat = "dd MMM yyyy"; // Format: 11 May 2025

  const handleDownload = (documentUrl?: string) => {
    if (documentUrl) {
      window.open(documentUrl, "_blank");
    } else {
      addToast("info", "Invoice document is not available");
    }
  };

  const data = useMemo(
    () => generateData(items, dateFormat, handleDownload),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [items]
  );
  const columns = useMemo(() => generateColumns(), []);

  return (
    <div className={clsx("relative flex bg-white", className)}>
      {isLoading && <Loading className="rounded-lg" />}
      <DataTable className="w-full overflow-x-auto [&_table]:table-auto" columns={columns} data={data} {...props} />
    </div>
  );
};
